
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import PurchaseModal from '../../components/modals/purchaseModal';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';


/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';


/*Assets*/
import OfferBanner from '../../assets/images/ofr-banner4.jpg';
import OfferLogo from '../../assets/images/purchase-logo.png';


class Notifiactions extends Component {
  constructor(props){
    super(props);
    this.state = {
      tabIndex: 1,
      data: [],
      apiLoading: false
    }
  }

  componentDidMount() {
    this.getData();
  }

  getData(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'notification/list';
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        console.log(response.data);
        this.setState({ data: response.data,apiLoading: false});
      }
      else {
        this.setState({apiLoading: false});
      }
    }.bind(this))
  }

  sendClick(tempId){
    var url = devconfig.vendor+'notification/mark-as-read';
    var data = JSON.stringify({
      "notification_id" : tempId

    })
    APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        console.log(data)
      }
    }.bind(this))
  }

  render() {

    return (
      <div>
       {
          this.state.apiLoading ?
             <APILoader/>
            :
            <div>
              {
                this.state.data.length ?
                  <div>
                    <div className="e-main-content e-vendor-table e-notification-topbar">
                      <div className="row">
                        {
                          this.state.data.map((item,index) => {
                            return(
                              <div className="col-lg-7 mb-3" key={index} onClick={this.sendClick.bind(this,item.id)}>
                                <Link to={ item.type == 1 ? "/scheduled-ads" : "/ads-plans"}>
                                  <div className="card">
                                    <div className="card-body">
                                      <p className="card-text">{item.text}</p>
                                    </div>
                                  </div>
                                </Link>
                              </div>

                              );
                            })
                        }
                      </div>
                    </div>
                  </div>
                  :
                    <NoDataFound head="Nothing Found" data="No Notifiaction Found"/>
              }
            </div>
        }
      </div>
    );
  }
}

export default Notifiactions;
